import * as React from 'react';

import { isEmpty } from 'lodash';
import PhoneInput from 'react-phone-input-2';
import { IDispatcher } from '../helpers/Dispatcher';
import { validateTelephone } from '../../core/validation/validate';
import {
  Component,
  formatterPhone,
  I18NString,
  isNullOrEmpty,
} from '../helpers/Utils';
import {
  IControlError,
  IControlSchema,
  IControlSchemaBase,
  ValidationResult,
} from '../../core/Controls';
import { COUNTRIES_CODE } from '../constants';

import Field from './components/Field';

import 'react-phone-input-2/lib/style.css';
import ErrorAlert from './components/ErrorAlert';

export interface TelephoneSchema extends IControlSchemaBase {
  placeholder?: string;
  value?: string;
  description: I18NString;
  notification: I18NString;
  disabled?: boolean;
}

interface Props {
  schema: TelephoneSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface State {
  value: string;
}

class Telephone extends Component<Props, State> {
  private input;

  state = {
    value: null,
  };

  componentDidMount() {
    const { value } = this.props.schema;
    const { error } = this.props;
    if (!isEmpty(value) && !this.props.visited) {
      this.props.dispatcher.onVisit(this.props.schema.id);
    }

    if (error) {
      return;
    }

    const validationResult = validateTelephone(value);

    this.props.dispatcher.setError(
      this.props.schema.id,
      value,
      validationResult?.isError
        ? { message: validationResult.message }
        : undefined,
      false,
    );

    // this.props.dispatcher.onBlur(this.props.schema.id, value, !validationResult, validationResult);
  }

  onBlur = () => {
    const value = formatterPhone(this.input.state.formattedNumber);
    const validationResult = validateTelephone(value);

    const _value = value === '+' ? '' : value;

    this.props.dispatcher.onBlur(
      this.props.schema.id,
      _value,
      validationResult && validationResult.isError,
      validationResult &&
        validationResult.isError && { message: validationResult.message },
    );
    this.props.dispatcher.onVisit(this.props.schema.id);
  };

  onChange = () => {
    const value = formatterPhone(this.input.state.formattedNumber);
    this.setState({ value });
  };

  onPaste = (event: ClipboardEvent) => {
    event.preventDefault();
    const paste = event?.clipboardData?.getData('text');

    this.setState({ value: formatterPhone(paste) });
  };

  render() {
    let { value } = this.props.schema;
    const { error, visited } = this.props;
    value = this.state.value === null ? value : this.state.value;
    const errorMessage = visited && error && error.message;
    let statusField = 'default';
    if (errorMessage) {
      statusField = 'error';
    } else if (!isNullOrEmpty(value) && !this.props.schema.disabled) {
      statusField = 'success';
    }

    return (
      <Field {...this.props.schema} status={statusField}>
        <PhoneInput
          // @ts-ignore
          ref={(node) => {
            this.input = node;
          }}
          autoFormat
          defaultCountry="ru"
          country="ru"
          onlyCountries={this.props.schema?.extra?.countries || COUNTRIES_CODE}
          value={value}
          disabled={this.props.schema.disabled}
          onChange={this.onChange}
          onBlur={this.onBlur}
          inputProps={{ onPaste: this.onPaste }}
          inputStyle={{
            width: '100%',
            borderColor: statusField !== 'success' ? '#ccc' : '#4eb43e',
          }}
          buttonStyle={{
            borderColor: statusField !== 'success' ? '#ccc' : '#4eb43e',
          }}
        />
        <ErrorAlert errorMessage={errorMessage} />
      </Field>
    );
  }
}

export function createTelephone(
  schema: IControlSchema,
  api: any,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <Telephone
      schema={schema as TelephoneSchema}
      dispatcher={dispatcher}
      error={error}
      visited={visited}
    />
  );
}
